<template>
    <div>
        <div class="white-box md:mb-5">
            <transition
                name="opacity"
                mode="out-in"
            >
                <Skeletons v-if="isGettingData>0" />
                <div v-else>
                    <h4 class="text-error mb-2.5 font-normal">
                        您目前保單的繳別為{{ userInfo.mopText }} / 繳費方式為{{ userInfo.payKindText }}
                    </h4>
                    <div class="border-t border-gray-100 text-base mb-7 py-4 md:py-5">
                        <h4 class="text-secondary mb-2.5 font-bold">
                            請選擇欲變更之繳別
                        </h4>
                        <Radio
                            v-for="(item,index) in mopList"
                            :key="index"
                            v-model:checkedValue="selected"
                            :value="item.value"
                            :text="item.mopCH"
                            :disabled="userInfo.mop===item.value || item.disabled"
                            class="mb-2.5 items-baseline"
                        />
                    </div>
                </div>
            </transition>
        </div>
        <PopupBase
            v-model:visiblePopup="visiblePopup"
            closeicon
            :params="{
                title: '重要提醒',
                isErrorButton: false,
                confirmButton: '確定',
                cancelButton: '我要變更',
            }"
            @cancel="addD1"
            @confirm="visiblePopup = false"
        >
            <template #content>
                <p class="word-">
                    繳別變更為月繳，需同時變更繳費方式為『自行繳費』，請確認是否辦理。
                </p>
            </template>
        </PopupBase>
        <Bottombar>
            <template #right>
                <ButtonNextService
                    v-model:isSubmitOk="isSubmitOk"
                    :disabled="selected===userInfo.mop||isGettingData>0"
                    @click="saveAndgoNext"
                />
            </template>
        </Bottombar>
        <Loading :isLoading="isLoading" />
    </div>
</template>

<script>
import { ref, computed, inject, reactive } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { getMopInfoB1, getInfoB1, submitB1 } from '@/apis/B1';
import Bottombar from '@/components/layout/Bottombar.vue';
import ButtonNextService from '@/components/buttons/ButtonNextService.vue';
import Loading from '@/components/Loading.vue';
import Radio from '@/components/radios/Radio.vue';
import Skeletons from './Skeletons.vue';
import PopupBase from '@/components/dialogs/Popup.vue';
import { addAndInsertService } from '@/utils/changeItems/insertService';

export default {
    components: {
        Bottombar,
        Loading,
        Radio,
        ButtonNextService,
        Skeletons,
        PopupBase,
    },
    setup() {
        const $vfm = inject('$vfm');
        const route = useRoute();
        const { code } = route.meta;
        const store = useStore();
        const isSubmitOk = ref(false);
        const isLoading = ref(false);
        const isGettingData = ref(0);
        const selected = ref('');
        const mopList = ref([]);
        const userInfo = ref({});
        const visiblePopup = ref(false);
        const result = computed(() => store.state.services.changeItemsResult[code]);
        const state = reactive({
            isSubmissionNote: false,
        });

        // 取得api資料
        const getData = () => {
            isGettingData.value = 2;
            getInfoB1().then(res => {
                userInfo.value = res.data;
                selected.value = res.data.mop;
            }).finally(() => {
                isGettingData.value -= 1;
            });
            getMopInfoB1().then((res) => {
                mopList.value = res.data.mopList.map(i => {
                    i.value = i.mop;
                    return i;
                });
            }).finally(() => {
                isGettingData.value -= 1;
            });
        };
        if (!result.value) {
            getData();
        } else {
            const { originList, storeList, selectVal } = result.value;

            selected.value = selectVal;
            userInfo.value = originList;
            mopList.value = storeList;
        }

        const saveAndgoNext = () => {
            isLoading.value = true;

            const payload = {
                mop: selected.value,
                ...(state.isSubmissionNote ? { ifPayingMessage: true } : {})
            };

            submitB1(payload).then(res => {
                const value = {
                    storeList: mopList.value,
                    originList: userInfo.value,
                    selectVal: selected.value,
                };

                if(res.data.submissionNote && !state.isSubmissionNote) {
                    var params = {
                      content: `${res.data.submissionNote}`.replace(/\n/g,"<br>"),
                      confirmButton: '確認',
                      cancelButton: null,
                      closeicon: false
                    };
                    investModalShow(params); // 顯示錯誤提示
                    state.isSubmissionNote = true;
                    return;
                }

                store.dispatch('services/setChangeItemsResult', { code, value });
                if (res.data.confirmMAddD1) {
                    visiblePopup.value = true;
                } else {
                    isSubmitOk.value = true;
                }
            }).finally(() => {
                isLoading.value = false;
            });
        };

        const investModalShow = (params,vl) => {
            $vfm.show({
                component: 'InvestDialog',
                params,
                on: {
                    confirm() {
                        $vfm.hide('InvestDialog');
                        if(vl())vl();
                    },
                    closed() {
                        $vfm.hide('InvestDialog');
                    }
                },
            });
        };

        const addD1 = async () => {
            isLoading.value = true;
            await addAndInsertService('D1', code);
            isLoading.value = false;
        };

        return {
            selected,
            mopList,
            userInfo,
            isLoading,
            isGettingData,
            saveAndgoNext,
            isSubmitOk,
            visiblePopup,
            addD1,
        };
    },
};
</script>
